import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Pipe, PipeTransform } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";
import { AngularEditorConfig } from "@kolkov/angular-editor";

import { FormIsValidDTO } from "src/app/parametrage/core/model/form-is-valid-dto";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { ExecuterAllTask } from "src/app/mon-portefeuille/core/model/executer-all-task";
import { TaskService } from "src/app/mon-portefeuille/core/service/task.service";

@Component({
  selector: "app-form-avis-client",
  templateUrl: "./form-avis-client.component.html",
  styleUrls: ["./form-avis-client.component.scss"],
})
export class FormAvisClientComponent implements OnInit {
  requestId: string;
  taskId: string;

  checkFormDTO: FormIsValidDTO;
  command: ExecuterAllTask = new ExecuterAllTask();

  pressButton: Boolean = false;
  form: FormGroup;

  name = "Angular 6";
  htmlContent = "";

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "8rem",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    toolbarHiddenButtons: [["bold"]],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public sanitizer: DomSanitizer,
    private _formulaireService: FormulaireService,
    private _taskService: TaskService
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      avis: [null, Validators.compose([Validators.required])],
      commentaire: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.requestId = params["requestId"];
      this.taskId = params["taskId"];
      this.checkIfFormIsValid(this.taskId);
    });
  }

  checkIfFormIsValid(taskId) {
    this._formulaireService.checkForm(taskId).subscribe(
      (data) => {
        this.checkFormDTO = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  executeTask(): void {
    this.command.taskId = this.taskId;
    this.command.requestId = this.requestId;
    this.command.messageText = this.htmlContent;

    this.pressButton = true;

    this.spinner.show();
    this._taskService
      .executerAllTask(this.command)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  cancel(): void {
    this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
  }
}
